/* WWC related row (31 Oct 2026). See snippets/wwc-related-products.liquid. No dependencies. */
(function () {
  var root = document.querySelector('[data-wwc-rp]');
  if (!root || root.__wwc) return; root.__wwc = 1;
  var cfg; try { cfg = JSON.parse(root.querySelector('[data-wwc-rp-json]').textContent); } catch (e) { return kill(); }
  var MAX = 8, MIN = 2;
  var GENDER = { women: 'F', womens: 'F', woman: 'F', ladies: 'F', lady: 'F', female: 'F', maternity: 'F', men: 'M', mens: 'M', male: 'M', kids: 'K', kid: 'K', childrens: 'K', children: 'K', child: 'K', junior: 'K', juniors: 'K', youth: 'K', boys: 'K', girls: 'K', unisex: 'U' };
  var COLOURS = 'yellow orange navy black red blue green grey gray white royal pink purple brown beige khaki olive charcoal graphite sand stone tan bottle burgundy maroon sky silver gold camo camouflage multi high visibility hi vis viz hivis fluo fluorescent'.split(' ');
  var STOP = 'and with the of for in a an to on by plus new'.split(' ');
  var CLS = {
    top: 'jacket jackets coat coats parka parkas softshell fleece gilet gilets bodywarmer bodywarmers vest vests hoodie hoody sweatshirt sweatshirts jumper jumpers polo polos t-shirt tshirt tee tees shirt shirts blouse blouses blazer blazers tabard tabards bomber anorak smock top tops sweater cardigan baselayer tunic waistcoat waistcoats'.split(' '),
    bottom: 'trousers trouser shorts short pants pant chinos chino skirt skirts leggings overtrousers jeans joggers combat'.split(' '),
    full: 'coverall coveralls overall overalls boilersuit boilersuits dungarees bib'.split(' '),
    feet: 'boot boots shoe shoes trainer trainers rigger riggers wellington wellingtons clog clogs sandal sandals'.split(' '),
    socks: 'sock socks insole insoles'.split(' '),
    hands: 'glove gloves gauntlet gauntlets'.split(' '),
    head: 'hat hats cap caps beanie beanies helmet helmets balaclava snood'.split(' ')
  };
  var PAIR = { top: ['bottom'], bottom: ['top'], full: ['top'], feet: ['socks'], socks: ['feet'], head: ['top'], hands: [] };
  var PAIRWORDS = { top: ['trousers', 'trouser', 'shorts', 'skirt', 'waistcoat'], bottom: ['jacket', 'softshell', 'fleece', 'gilet', 'polo', 'shirt', 'blazer'], full: ['jacket', 'fleece'], feet: ['socks', 'sock', 'insoles', 'insole'], socks: ['boot', 'boots', 'shoe', 'shoes', 'trainers'], head: ['jacket', 'fleece'], hands: [] };
  var GENERIC_TAGS = /^(clothing|footwear|ppe|workwear|high visibility|hi-vis|hi vis|women'?s|men'?s|male|female|unisex|kids|new|sale)$/i;

  function words(t) { return (t || '').toLowerCase().replace(/[’'`]/g, '').replace(/®|™/g, '').replace(/[^a-z0-9\/\-]+/g, ' ').split(/\s+/).filter(Boolean); }
  var vendorWords = words(cfg.vendor);
  function genderOf(title, g, tags) {
    var w = words(title), i, x;
    for (i = 0; i < w.length; i++) { x = GENDER[w[i].replace(/-/g, '')]; if (x && x !== 'U') return x; }
    var gs = (g || '').toLowerCase();
    if (/women|ladies|female/.test(gs)) return 'F';
    if (/kid|child|junior/.test(gs)) return 'K';
    for (i = 0; i < (tags || []).length; i++) { var t = String(tags[i]).toLowerCase(); if (t === 'fit:ladies' || t === "women's" || t === 'women' || t === 'ladies') return 'F'; if (t === 'kids' || t === "kids'" || t === 'fit:kids') return 'K'; }
    if (/(^|\s)men/.test(gs) || /male/.test(gs)) return 'M';
    return 'U';
  }
  function classOf(w) { for (var k in CLS) for (var i = w.length - 1; i >= 0; i--) if (CLS[k].indexOf(w[i]) > -1) return k; return ''; }
  function core(title) {
    return words(title).map(function (x) { return x.replace(/-/g, ''); }).filter(function (x) {
      return x.length > 1 && !/\d/.test(x) && vendorWords.indexOf(x) < 0 && !GENDER[x] && COLOURS.indexOf(x) < 0 && STOP.indexOf(x) < 0;
    });
  }
  function colourOf(title) { var w = words(title), out = []; for (var i = 0; i < w.length; i++) if (COLOURS.indexOf(w[i]) > -1 && 'high visibility hi vis viz hivis fluo fluorescent'.indexOf(w[i]) < 0) out.push(w[i]); return out.join(' '); }
  function hv(t) { return /hi-?vis|hi-?viz|high vis/i.test(t || '') ? 1 : 0; }
  function jac(a, b) { var A = {}, n = 0, u = 0, k; a.forEach(function (x) { A[x] = 1; }); var B = {}; b.forEach(function (x) { B[x] = 1; }); for (k in A) { u++; if (B[k]) n++; } for (k in B) if (!A[k]) u++; return u ? n / u : 0; }
  function q(s) { return '"' + String(s).replace(/"/g, '') + '"'; }
  function rangeTag() {
    var tags = cfg.tags || [], i, t;
    if (cfg.range) {
      var rw = words(cfg.range).filter(function (x) { return vendorWords.indexOf(x) < 0 && x.length > 2; });
      for (i = 0; i < tags.length; i++) { t = tags[i]; if (t.indexOf(':') > -1 || GENERIC_TAGS.test(t)) continue; var tw = words(t); if (rw.length && rw.every(function (x) { return tw.indexOf(x) > -1; })) return t; }
      for (i = 0; i < tags.length; i++) { t = tags[i]; if (t.indexOf(':') < 0 && rw.some(function (x) { return words(t).indexOf(x) > -1; })) return t; }
    }
    for (i = 0; i < tags.length; i++) if (/^[A-Z]{1,4}\d{1,2}$/.test(tags[i])) return tags[i];
    return '';
  }
  function famTag() { var t = cfg.tags || []; for (var i = 0; i < t.length; i++) if (/^family:/i.test(t[i])) return t[i]; return ''; }

  var me = { w: words(cfg.title), core: core(cfg.title), g: genderOf(cfg.title, cfg.gender, cfg.tags), col: colourOf(cfg.title) };
  me.cls = classOf(me.w);
  var rTag = rangeTag(), fTag = famTag();
  var exclude = {}; exclude[cfg.id] = 1; String(cfg.comp || '').split(',').forEach(function (x) { if (x) exclude[+x] = 1; });
  var garmentWords = []; for (var k in CLS) garmentWords = garmentWords.concat(CLS[k]);
  var styleWords = me.core.filter(function (x) { return garmentWords.indexOf(x) < 0; }).slice(0, 4);

  function sURL(query, sec, n) { return cfg.search + '?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=none&options%5Bunavailable_products%5D=hide&section_id=' + sec; }
  function getData(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
      var m = h.match(/data-wwc-rp-data>([\s\S]*?)<\/script>/); if (!m) return [];
      try { return JSON.parse(m[1]).filter(Boolean); } catch (e) { return []; }
    }).catch(function () { return []; });
  }
  function vq() { return 'vendor:' + q(cfg.vendor); }

  function run() {
    var jobs = [];
    // 1. same style / range (twins + same-range pieces)
    if (styleWords.length) jobs.push(getData(sURL(vq() + (rTag ? ' AND tag:' + q(rTag) : '') + ' AND ' + styleWords.map(function (w) { return 'title:' + w; }).join(' AND '), 'wwc-related-data')));
    else jobs.push(Promise.resolve([]));
    // 2. same-brand items that go with it
    var pw = PAIRWORDS[me.cls] || [];
    if (pw.length) jobs.push(getData(sURL(vq() + ' AND (' + pw.map(function (w) { return 'title:' + w; }).join(' OR ') + ')' + (rTag ? ' AND tag:' + q(rTag) : (fTag && /^(top|bottom|full)$/.test(me.cls) ? ' AND tag:' + q(fTag) : '')), 'wwc-related-data')));
    else jobs.push(Promise.resolve([]));
    Promise.all(jobs).then(function (res) {
      var picks = choose(res[0], res[1], []);
      if (picks.length >= 4) return picks;
      return getData(cfg.recs + '?product_id=' + cfg.id + '&limit=10&intent=related&section_id=wwc-related-data').then(function (rec) { return choose(res[0], res[1], rec); });
    }).then(function (picks) {
      if (picks.length < MIN) return kill();
      var hq = picks.map(function (p) { return 'handle:' + p.h; }).join(' OR ');
      return fetch(sURL(hq, 'wwc-related-cards'), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) { paint(picks, h); });
    }).catch(kill);
  }

  function lab(p) { return p.kind === 'twin' ? ({ F: "Women's version", M: "Men's version", K: "Kids' version", U: 'Unisex version' })[p.pg] : (p.kind === 'colour' ? 'Also in ' + p.pcol.replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : ''); }

  function choose(styleRes, pairRes, recRes) {
    var seen = {}, twins = [], pairs = [], fill = [];
    function ok(p) { return p && p.a && !exclude[p.id] && !seen[p.id] && String(p.v).toLowerCase() === String(cfg.vendor).toLowerCase(); }
    styleRes.concat(pairRes).forEach(function (p) {
      if (!ok(p)) return;
      var w = words(p.t), c = core(p.t), cls = classOf(w), g = genderOf(p.t, p.g, p.tg), sim = jac(me.core, c), col = colourOf(p.t);
      var sameRange = rTag && (p.tg || []).indexOf(rTag) > -1;
      var sameHv = hv(p.t) === hv(cfg.title);
      if (cls === me.cls && sameHv && sim >= 0.75 && g !== me.g && !(me.g === 'M' && g === 'U') && !(me.g === 'U' && g === 'M')) { seen[p.id] = 1; p.kind = 'twin'; p.pg = g; p.score = 100 + sim * 10; twins.push(p); return; }
      if (cls === me.cls && sameHv && sim >= 0.99 && g === me.g && col && col !== me.col) { seen[p.id] = 1; p.kind = 'colour'; p.pcol = col; p.score = 90; twins.push(p); return; }
      var pairOk = (PAIR[me.cls] || []).indexOf(cls) > -1;
      if (!pairOk) return;
      var shareStyle = styleWords.filter(function (x) { return c.indexOf(x) > -1; }).length;
      var extra = c.filter(function (x) { return me.core.indexOf(x) < 0 && garmentWords.indexOf(x) < 0; }).length;
      var s = 10 - extra * 1.5 + shareStyle * 4 + (sameRange ? 3 : 0) + (fTag && (p.tg || []).indexOf(fTag) > -1 ? 1 : 0) + (g === me.g || g === 'U' || me.g === 'U' ? 2 : 0);
      if (col && col === me.col) s += 1;
      seen[p.id] = 1; p.kind = 'pair'; p.score = s; p.key = cls + ':' + c.slice().sort().join(' ') + ':' + g; pairs.push(p);
    });
    twins.sort(function (a, b) { return b.score - a.score; }); pairs.sort(function (a, b) { return b.score - a.score; });
    var keys = {}; pairs = pairs.filter(function (p) { if (keys[p.key]) return false; keys[p.key] = 1; return true; });
    twins = twins.slice(0, 3);
    (recRes || []).forEach(function (p) {
      if (!ok(p)) return;
      var cls = classOf(words(p.t));
      // fallback stays on-topic: same kind of item, something that goes with it, or the same product type
      if (!(cls && (cls === me.cls || (PAIR[me.cls] || []).indexOf(cls) > -1)) && String(p.ty).toLowerCase() !== String(cfg.type).toLowerCase()) return;
      seen[p.id] = 1; p.kind = 'rec'; fill.push(p);
    });
    return twins.concat(pairs).slice(0, MAX).concat(fill).slice(0, MAX);
  }

  function paint(picks, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html'), byH = {};
    doc.querySelectorAll('.wwc-rp__card[data-h]').forEach(function (n) { byH[n.getAttribute('data-h')] = n; });
    var row = root.querySelector('[data-wwc-rp-row]'), frag = document.createDocumentFragment(), n = 0, kinds = {};
    picks.forEach(function (p) {
      var card = byH[p.h]; if (!card) return;
      var li = document.createElement('li'); li.className = 'wwc-rp__item'; li.setAttribute('data-kind', p.kind);
      var l = document.createElement('span'); l.className = 'wwc-rp__lab'; l.textContent = lab(p) || ''; li.appendChild(l);
      card.querySelectorAll('a[href*="_sid="], a[href*="_pos="]').forEach(function (a) { try { var u = new URL(a.getAttribute('href'), location.href); ['_pos', '_sid', '_ss'].forEach(function (k) { u.searchParams.delete(k); }); a.setAttribute('href', u.pathname + u.search + u.hash); } catch (e) {} });
      while (card.firstChild) li.appendChild(card.firstChild);
      frag.appendChild(li); n++; kinds[p.kind] = 1;
    });
    if (n < MIN) return kill();
    var h = root.querySelector('[data-wwc-rp-h]');
    var twin = kinds.twin || kinds.colour, pair = kinds.pair;
    h.textContent = twin && pair ? 'Also available & pairs well with' : twin ? 'Also available' : pair ? 'Pairs well with' : 'More from ' + cfg.vendor;
    if (!twin) frag.querySelectorAll('.wwc-rp__lab').forEach(function (x) { x.remove(); });
    row.innerHTML = ''; row.appendChild(frag); row.removeAttribute('aria-hidden');
    root.setAttribute('data-state', 'done'); root.setAttribute('data-kinds', Object.keys(kinds).join(' ')); root.setAttribute('data-count', n);
    document.dispatchEvent(new CustomEvent('wwc:related-ready', { detail: { count: n, kinds: Object.keys(kinds) } }));
  }

  function kill() {
    if (!root) return;
    var above = root.getBoundingClientRect().bottom < 0, h = root.offsetHeight;
    root.setAttribute('data-state', 'none'); root.style.display = 'none';
    if (above && h && !(window.CSS && CSS.supports && CSS.supports('overflow-anchor', 'auto'))) window.scrollBy(0, -h);
    document.dispatchEvent(new CustomEvent('wwc:related-ready', { detail: { count: 0, kinds: [] } }));
  }

  var started = false;
  function start() { if (started) return; started = true; run(); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: '1400px 0px' });
    io.observe(root);
  } else { start(); }
  // also start shortly after load, so a 'no matches' collapse happens while the row is still far below the fold (no visible shift)
  function idle() { (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(start, { timeout: 2500 }); }
  if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
})();
